// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__ythNb","ldsRoller":"LoadingSpinner_ldsRoller__tniUe"};